// extracted by mini-css-extract-plugin
module.exports = {"passRecoverWrap":"PasswordRecover_passRecoverWrap__domC8"};